import { Container, Grid, Box, } from '@mui/material';
import React from 'react';
import TestimonialsScss from './Testimonials.module.scss';
import Slider from "react-slick";
import Office from '../../Common/Image/office1.jpg';
function Testimonials() {
    var settings = {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div>
            <section id={TestimonialsScss.testimonials}>
                <Box className={TestimonialsScss.testimonials}>
                    <Container maxWidth='lg'>
                        <Grid container>
                            <Grid item xs={12} sm={12} ms={7}>
                                <Box className={TestimonialsScss.testimonialsHead}>
                                    <span>testimonials</span>
                                    <p>Awesome clients we've worked with</p>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                    <Box className={TestimonialsScss.testimonialsSlider}>
                        <Slider {...settings}>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                            <Box className={TestimonialsScss.testimonialsItem}>
                                <Box className={TestimonialsScss.testimonialsItemHead}>
                                    <span className={TestimonialsScss.testimonialsItemImg}>
                                        <img src={Office} alt=''></img>
                                    </span>
                                    <Box className={TestimonialsScss.testimonialsItemHeadRight}>
                                        <h5>darlene <br /> robertson</h5>
                                        <span>7/27/22</span>
                                    </Box>
                                </Box>
                                <Box className={TestimonialsScss.testimonialsItemContent}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book
                                </Box>
                            </Box>
                        </Slider>
                    </Box>
                </Box>
            </section>
        </div>
    )
}


export default Testimonials;
